import StaticConfig from './static-config';
import { createBugsnagClient, setGlobalBugsnag } from "@markham/react-services";
import Package from '../package.json';

const client = createBugsnagClient(StaticConfig, Package.version);

setGlobalBugsnag(client);

export default client;
